






















import { getGlobalHandle } from '@getaccept/lib-shared/src/helpers';
import { defineComponent, ref, computed, onMounted } from '@vue/composition-api';
import { SupportIntercomConstants } from '../constants/support-intercom-constants';
export default defineComponent({
  setup() {
    const messageCount = ref(0);
    const isOpened = ref(false);

    const messageNotification = computed(() => {
      if (messageCount.value > SupportIntercomConstants.truncateLimit) {
        return '...';
      }
      return messageCount.value;
    });

    const handleIntercomClick = () => {
      if (!getGlobalHandle().Intercom) {
        return;
      }

      if (!isOpened.value) {
        getGlobalHandle().Intercom('show');
      } else {
        getGlobalHandle().Intercom('hide');
      }
    };

    onMounted(() => {
      if (!getGlobalHandle().Intercom) {
        return;
      }

      getGlobalHandle().Intercom('onShow', () => {
        isOpened.value = true;
      });
      getGlobalHandle().Intercom('onHide', () => {
        isOpened.value = false;
      });
      getGlobalHandle().Intercom('onUnreadCountChange', unreadCount => {
        messageCount.value = unreadCount;
      });
    });

    return { messageCount, isOpened, messageNotification, handleIntercomClick };
  },
});
